export type XlsxCellValue = string | number | null;

interface XlsxCell {
  value(value: XlsxCellValue): void;
}

interface XlsxSheet {
  cell(row: number, col: number): XlsxCell;
}

export function writeRowsToSheet(
  sheet: XlsxSheet,
  rows: ReadonlyArray<ReadonlyArray<XlsxCellValue>>,
  startRow: number,
): void {
  rows.forEach((row, rowOffset) => {
    const rowIndex = startRow + rowOffset;
    row.forEach((cellValue, colIndex) => sheet.cell(rowIndex, colIndex + 1).value(cellValue));
  });
}
